import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { LoginSuccessAction, LogoutAction } from '../action/auth.action';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../reducers';
import { FetchProfile } from '../../../pages/my-profile/ngrx/action/profile.action';
import { IdentityService } from '../../service/identity/identity.service';
import { AuthService } from '../../service/auth/auth.service';

@Injectable()
export class AuthEffects {
  constructor(
    private readonly action$: Actions,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly identityService: IdentityService,
    private readonly store: Store<ApplicationState>,
  ) {}

  navigateToAppPage$ = createEffect(() =>
      this.action$.pipe(
        ofType(LoginSuccessAction),
        tap(() => this.store.dispatch(FetchProfile())),
      ), { dispatch: false },
  );

  navigateToLoginPage$ = createEffect(() =>
      this.action$.pipe(
        ofType(LogoutAction),
        tap(() => {
          this.authService.navigateToLoginPage();
        }),
      ),
    { dispatch: false },
  );
}
